module.exports = __webpack_public_path__ + "static/media/NSCA_CSCS1.350202f4.jpg";